// DS: i9.7
import React from 'react';
import IconWrap, { IconSize, Props } from '../../IconWrap';

const DollarSign: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <IconWrap size={IconSize.SMALLER} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M7.472 14v-1.243a5.8 5.8 0 0 1-1.804-.423q-.797-.34-1.244-.965-.447-.624-.423-1.552l.017-.032h2.308q0 .846.504 1.212t1.268.366q.74 0 1.13-.303a1 1 0 0 0 .398-.827q0-.51-.382-.832-.374-.322-1.292-.6-1.203-.34-1.992-.719-.78-.385-1.17-.902-.382-.524-.382-1.287 0-1.06.87-1.735.877-.682 2.357-.802V2h1.292v1.375q1.423.165 2.236.928.82.757.804 1.975l-.024.031H9.635q0-.744-.399-1.148-.398-.404-1.073-.404-.699 0-1.048.316-.342.309-.342.826 0 .492.358.801.366.303 1.333.6 1.195.366 1.975.757.789.384 1.17.902.39.518.391 1.262 0 1.09-.878 1.754-.87.656-2.357.776V14z"></path>
      </svg>
    </IconWrap>
  );
};
DollarSign.displayName = 'DollarSign';

export default DollarSign;
